import { BaseClient } from '../BaseClient';
import {
  EventTrade,
  EventTradeList,
  EventTradeRule,
  EventTradeRuleList,
} from '../compiled-protos/event_trade';
import { EventTradeServiceClient } from '../compiled-protos/event_trade.client';

class EventTradeClient extends BaseClient {
  self: EventTradeServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new EventTradeServiceClient(this.transport);
  }

  public async Create(req: EventTrade) {
    return await this.self.createEventTrade(req, this.getMetaData()).response;
  }

  public async Get(req: EventTrade) {
    return await this.self.getEventTrade(req, this.getMetaData()).response;
  }

  public async BatchGet(req: EventTrade) {
    return await this.self.batchGetEventTrade(req, this.getMetaData()).response;
  }

  public async Update(req: EventTrade) {
    return await this.self.updateEventTrade(req, this.getMetaData()).response;
  }

  public async Delete(req: EventTrade) {
    return await this.self.deleteEventTrade(req, this.getMetaData()).response;
  }

  public async CreateRule(req: EventTradeRule) {
    return await this.self.createEventTradeRule(req, this.getMetaData()).response;
  }

  public async GetRule(req: EventTradeRule) {
    return await this.self.getEventTradeRule(req, this.getMetaData()).response;
  }

  public async BatchGetRules(req: EventTradeRule) {
    return await this.self.batchGetEventTradeRule(req, this.getMetaData()).response;
  }

  public async UpdateRule(req: EventTradeRule) {
    return await this.self.updateEventTradeRule(req, this.getMetaData()).response;
  }

  public async DeleteRule(req: EventTradeRule) {
    return await this.self.deleteEventTradeRule(req, this.getMetaData()).response;
  }
}

export { EventTrade, EventTradeList, EventTradeRule, EventTradeRuleList, EventTradeClient };
